import ProjectItem from "components/common/ProjectItem";
import React from "react";
import useProjects from "helpers/custom-hooks/projects";
import useVisualize from "helpers/custom-hooks/visualize";
import { useSelector } from "react-redux";

const ProjectList = ({ projects, selectedProject, setSelectedProject }) => {
    const { getProject } = useProjects();
    const { visualize } = useVisualize();
    const bodyToken = useSelector((state) => state.project.bodyToken);

    async function handleSelectedProject(project) {
        setSelectedProject(project?.name);
        try {
            getProject(project.key, bodyToken);
            visualize(project.key);
        } catch (error) {
            throw new Error("An error occurred:", error);
        }
    }

    return (
        <div className="space-y-[6px] flex-1 overflow-y-auto px-4 pb-4 dark:bg-[#0D182]">
            {projects.map((project, index) => (
                <ProjectItem
                    key={index}
                    name={project?.name}
                    isSelected={selectedProject === project?.name}
                    onClick={() => handleSelectedProject(project)}
                />
            ))}
        </div>
    );
};

export default ProjectList;
